import React from "react";
import ReactDOM from "react-dom/client";

/**
 * Convert a Material UI icon component to a DOM element for use in AG Grid
 * @param IconComponent - Material UI icon component to render
 * @param fontSize - Font size for the icon (number in pixels or MUI size string)
 * @returns DOM span element containing the rendered icon
 */
export const muiIconToElement = (
  IconComponent: React.ElementType,
  fontSize: number | "inherit" | "small" | "medium" | "large" = 14,
): HTMLSpanElement => {
  const span = document.createElement("span");
  const root = ReactDOM.createRoot(span);
  root.render(<IconComponent sx={{ fontSize }} />);
  return span;
};
